import { faFileInvoiceDollar, faHome, faStore } from "@fortawesome/pro-light-svg-icons"
import {
    SUPPLIER_REPORTS_ACCOUNTING_CUSTOMER_SALES_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_MEETING_SERVICE_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_MERCHANT_SALES_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_POS_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_SUBSCRIPTIONS_ROUTE,
    SUPPLIER_REPORTS_ACCOUNTING_Z_REPORTS_ROUTE,
    SUPPLIER_REPORTS_MERCHANTS_ROUTE,
    SUPPLIER_REPORTS_ROUTE,
} from "../../../../constants/routes"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"
import { EnvironmentType } from "../../../environment/envTypes"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"

export function SupplierReportNavItems() {
    return (
        <>
            <LocalizedStrict id="supplier-nav-item-home">
                <NavMenuItem icon={faHome} dest={SUPPLIER_REPORTS_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="supplier-nav-item-merchant-access">
                <NavMenuItem icon={faStore} dest={SUPPLIER_REPORTS_MERCHANTS_ROUTE}>
                    Merchant Access
                </NavMenuItem>
            </LocalizedStrict>
            <LocalizedStrict id="supplier-nav-item-accounting-title" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper
                    icon={faFileInvoiceDollar}
                    dest={SUPPLIER_REPORTS_ACCOUNTING_ROUTE}
                    title="Accounting"
                >
                    <MatchEnvironment
                        environments={[
                            EnvironmentType.Local,
                            EnvironmentType.Test,
                            EnvironmentType.Demo,
                            EnvironmentType.QA,
                        ]}
                    >
                        <LocalizedStrict id="supplier-nav-item-merchant-sales">
                            <NavMenuSubItem route={SUPPLIER_REPORTS_ACCOUNTING_MERCHANT_SALES_ROUTE}>
                                Merchant Sales
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}
                    >
                        <LocalizedStrict id="supplier-nav-item-customer-sales">
                            <NavMenuSubItem route={SUPPLIER_REPORTS_ACCOUNTING_CUSTOMER_SALES_ROUTE}>
                                Customer Sales
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                    <LocalizedStrict id="supplier-nav-item-pos">
                        <NavMenuSubItem route={SUPPLIER_REPORTS_ACCOUNTING_POS_ROUTE}>POS</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="supplier-nav-item-z-reports">
                        <NavMenuSubItem route={SUPPLIER_REPORTS_ACCOUNTING_Z_REPORTS_ROUTE}>
                            Z-reports
                        </NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}
                    >
                        <LocalizedStrict id="supplier-nav-item-meeting-service">
                            <NavMenuSubItem route={SUPPLIER_REPORTS_ACCOUNTING_MEETING_SERVICE_ROUTE}>
                                Meeting service
                            </NavMenuSubItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="supplier-nav-item-subscriptions">
                            <NavMenuSubItem route={SUPPLIER_REPORTS_ACCOUNTING_SUBSCRIPTIONS_ROUTE}>
                                Subscriptions
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
        </>
    )
}
